import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth" }
const _hoisted_2 = { class: "auth__left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Fiók összekapcsolás!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Ehhez a profilhoz tartozó e-mail címmel már regisztáltál. Szeretnéd társítani ezt a fiókot? Add meg az RTL.hu profil jelszavad.", -1)
const _hoisted_5 = {
  key: 0,
  ref: "errorBlock",
  class: "form-errors"
}
const _hoisted_6 = { class: "form-errors__error" }
const _hoisted_7 = { class: "auth__form-group" }
const _hoisted_8 = { class: "auth__form-group" }
const _hoisted_9 = { class: "auth__form-group auth__row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "auth__col" }, null, -1)
const _hoisted_11 = { class: "auth__col auth__forgot" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Elfelejtettem a jelszavam")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "auth__button auth__button--primary"
}, " Folytatás ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_ctx.modalIsOpen)
    ? (_openBlock(), _createBlock(_component_modal, {
        key: 0,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalIsOpen = false))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("form", {
                class: "auth__form",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.link && _ctx.link(...args)), ["prevent"]))
              }, [
                (_ctx.hasFieldError('error'))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                      _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                    ], 512))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_text_input, {
                    modelValue: _ctx.loginID,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginID) = $event)),
                    label: "E-mail cím",
                    "error-msg": _ctx.getFieldErrorValue('loginID')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_password_input, {
                    modelValue: _ctx.linkData.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.linkData.password) = $event)),
                    label: "Jelszó",
                    "error-msg": _ctx.getFieldErrorValue('password')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_router_link, { to: _ctx.passwordUrl }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _hoisted_13
              ], 32)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}